import { IAppState, TActions } from '../../../common/state';
import { EBuildingType } from '../../../json_query';

export const IBuildingTypeAddedActionType = 'filters/building_type/BUILDING_TYPE_ADDED';
export const IBuildingTypeRemovedActionType = 'filters/building_type/BUILDING_TYPE_REMOVED';
export const IBuildingTypeBuildingAddedActionType = 'filters/building_type/BUILDING_TYPE_BUILDING_ADDED';
export const IBuildingTypeBuildingRemovedActionType = 'filters/building_type/BUILDING_TYPE_BUILDING_REMOVED';

export interface IBuildingTypeAddedAction {
  type: 'filters/building_type/BUILDING_TYPE_ADDED';
  value: EBuildingType;
}

export interface IBuildingTypeRemovedAction {
  type: 'filters/building_type/BUILDING_TYPE_REMOVED';
  value: EBuildingType;
}

export interface IBuildingTypeBuildingAddedAction {
  type: 'filters/building_type/BUILDING_TYPE_BUILDING_ADDED';
  value: EBuildingType;
}

export interface IBuildingTypeBuildingRemovedAction {
  type: 'filters/building_type/BUILDING_TYPE_BUILDING_REMOVED';
  value: EBuildingType;
}

export function buildingTypeAdded(value: EBuildingType): IBuildingTypeAddedAction {
  return {
    type: IBuildingTypeAddedActionType,
    value,
  };
}

export function buildingTypeRemoved(value: EBuildingType): IBuildingTypeRemovedAction {
  return {
    type: IBuildingTypeRemovedActionType,
    value,
  };
}

export function buildingTypeBuildingAdded(value: EBuildingType): IBuildingTypeBuildingAddedAction {
  return {
    type: IBuildingTypeBuildingAddedActionType,
    value,
  };
}

export function buildingTypeBuildingRemoved(value: EBuildingType): IBuildingTypeBuildingRemovedAction {
  return {
    type: IBuildingTypeBuildingRemovedActionType,
    value,
  };
}

export function buildingTypeReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case IBuildingTypeAddedActionType:
      const buildingTypes =
        (state.filters.jsonQuery.building_type2 && state.filters.jsonQuery.building_type2.value) || [];

      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: {
            ...state.filters.jsonQuery,
            building_type2: {
              type: 'terms',
              value: buildingTypes.concat(action.value),
            },
          },
        },
      };
    case IBuildingTypeRemovedActionType:
      let buildingTypesNext =
        (state.filters.jsonQuery.building_type2 && state.filters.jsonQuery.building_type2.value) || [];

      buildingTypesNext = buildingTypesNext.filter(buildingType => buildingType !== action.value);

      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: {
            ...state.filters.jsonQuery,
            building_type2:
              buildingTypesNext.length > 0
                ? {
                    type: 'terms',
                    value: buildingTypesNext,
                  }
                : undefined,
          },
        },
      };
    case IBuildingTypeBuildingAddedActionType:
      const buildingTypesBuilding =
        (state.filters.jsonQuery.building_type__building && state.filters.jsonQuery.building_type__building.value) ||
        [];

      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: {
            ...state.filters.jsonQuery,
            building_type__building: {
              type: 'terms',
              value: buildingTypesBuilding.concat(action.value),
            },
          },
        },
      };
    case IBuildingTypeBuildingRemovedActionType:
      let buildingTypesBuildingNext =
        (state.filters.jsonQuery.building_type__building && state.filters.jsonQuery.building_type__building.value) ||
        [];

      buildingTypesBuildingNext = buildingTypesBuildingNext.filter(buildingType => buildingType !== action.value);

      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: {
            ...state.filters.jsonQuery,
            building_type__building:
              buildingTypesBuildingNext.length > 0
                ? {
                    type: 'terms',
                    value: buildingTypesBuildingNext,
                  }
                : undefined,
          },
        },
      };
    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'advanced-buildingType') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: {
              ...state.filters.jsonQuery,
              building_type2: undefined,
            },
          },
        };
      } else if (action.tag.type === 'advanced-buildingTypeBuilding') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: {
              ...state.filters.jsonQuery,
              building_type__building: undefined,
            },
          },
        };
      }

      return state;

    case 'filters/tags/ALL_TAGS_REMOVED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: {
            ...state.filters.jsonQuery,
            building_type2: undefined,
            building_type__building: undefined,
          },
        },
      };
    default:
      return state;
  }
}
